import React, { useState, useContext, useEffect } from 'react';
import { browserName, browserVersion } from "react-device-detect";
import { useSelector, useDispatch } from "react-redux";
import Navbar from '../Comman_Layout/Header/Navbar';
import Banner from '../Banner/Banner';
import SoftwareDevelopment from '../Software_Dev_Section/SoftwareDevelopment';
import ServiceHighlights from '../Home_Page_component/ServiceHighlights';
import FeaturedSolutions from '../Home_Page_component/FeaturedSolutions';
import OurServices from '../Home_Page_component/OurServices';
import AfterServiceDD from '../Home_Page_component/AfterServiceDD';
import WhatUsersSaying from '../Home_Page_component/WhatUsersSaying';
import UnderstandUsersExpectation from '../Home_Page_component/UnderstandUsersExpectation';
import OurClient from '../Home_Page_component/OurClient';
import SubscribeSection from '../Home_Page_component/SubscribeSection';
import Footer from '../Comman_Layout/Footer/Footer';
import Gotop from '../Comman_Layout/Gotop';
import StickySocial from '../Comman_Layout/StickySocial';
import Home_certificate from '../Home_Page_component/Home_certificate';
import Swal from 'sweetalert2';
import MetaContext from '../../Context/MetaContext';
import { Helmet } from 'react-helmet-async'
// import axios from 'axios';
import $ from 'jquery';
import { getHomePageMetaData } from '../../Redux/action/Homeaction';
import HomeNavbar from '../Comman_Layout/Header/HomeNavbar';
import { Link } from 'react-router-dom';
const Home = () => {
  //get Data from Reducer

  const dispatch = useDispatch();
  const [isLoading, setisLoading] = useState(false);
  useEffect(() => {
    // setisLoading(false);
    // dispatch(getHomePageMetaData());
    // setisLoading(true);
    // code to show modal only once on Site Reloading
    // let pop_status = localStorage.getItem('pop_status');
    // if (pop_status) {
    //   $("#initialModal").modal("show")
    //   localStorage.setItem('pop_status', 0);
    // }
    $("#initialModal").modal("show")
  }, []);
  const homepagemetadataDetail = useSelector((state) => state.HomeReducer ? state.HomeReducer.homepagemetadataList.data : "");
  // console.log('Home page meta data =', homepagemetadataDetail);

  //pause youtube video
  // function pauseVideo() {
  //   console.log("trying to pause")
  //   let video = document.getElementById("iframeyt");
  //   video.contentWindow.postMessage('{"event":"command", "func":"stopVideo", "args":""}', '*');
  // }


  if (browserName == "Safari" && browserVersion < 16) {
    Swal.fire(
      'Your browser is NOT supported. Please upgrade to latest version of Safari.',
      'Your current version of ' + browserName + " " + browserVersion,
      'error'
    )
  }




  return (
    <>
      {
        isLoading && <Helmet>
          <title> {homepagemetadataDetail ? `${homepagemetadataDetail.metatag}` : `Best Web and Mobile App Design Company | Alobha Technologies`} </title>
          <meta name="description" content={homepagemetadataDetail ? `${homepagemetadataDetail.metadescription}` : ""} />
          <meta name="keywords" content={homepagemetadataDetail ? `${homepagemetadataDetail.keyword}` : ""} />
        </Helmet>
      }

      {/* <Navbar /> */}
      <HomeNavbar />
      <Banner />
      <SoftwareDevelopment />
      <ServiceHighlights />
      <FeaturedSolutions />
      <OurServices />
      <AfterServiceDD />
      <WhatUsersSaying />
      <UnderstandUsersExpectation />
      <OurClient />
      <Home_certificate />
      <SubscribeSection />
      <Footer />
      <Gotop />
      <StickySocial />

      <div class="modal fade" id="initialModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style={{width: "500px"}}>
          <div class="modal-content">
            <div class="modal-header" style={{position:"relative",padding:"0px", background:"red",borderBottom:"0"}}>
              {/* <h5 class="modal-title" id="exampleModalLabel">Welcome to Alobha Technologies</h5> */}
              <button type="button" class="close" id='close' data-dismiss="modal" aria-label="Close" style={{background: "#fff",bottom: "-25px",position: "absolute",right: "21px", zIndex: "1",  padding:" 5px 10px"}}>
                <span aria-hidden="true">&times;</span>
              </button>
              {/* <button type="button" class="close" id='close' data-dismiss="modal" aria-label="Close" onClick={pauseVideo} style={{background: "#fff",bottom: "-25px",position: "absolute",right: "21px", zIndex: "1",  padding:" 5px 10px"}}>
                <span aria-hidden="true">&times;</span>
              </button> */}
            </div>
            <div class="modal-body modalbgblack p-0">
              {/* <iframe width="100%" className='iframeyt' id='iframeyt' height="400px" src="https://www.youtube.com/embed/QvYgBXb50bs?autoplay=1&enablejsapi=1" title="Discover the Secrets of Alobha Technologies with this Introduction Video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
              <img src='assets/img/offer.gif' className='img-fluid' />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Home